import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CustomToast from "../Components/CustomToast/CustomToast";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { contact } from "../Services/api";
import HowItWorksImg from "./../Images/how-it-works.png";

const Contact = () => {
  const defaultDetails = {
    fullName: "",
    email: "",
    message: "",
  };

  const schema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    fullName: Yup.string().required("Full name is required"),
  });

  const doContact = async (values) => {
    try {
      const contactResp = await contact(values);
      toast(<CustomToast type="success" message={contactResp.msg} />, {
        autoClose: 3000,
      });
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <Header />
      <div
        className="banner w-100 mb-90"
        style={{ backgroundImage: `url(${HowItWorksImg})` }}
      >
        <div className="container">
          <div className="banner-title text-center">
            <h1>Contact Us</h1>
            <p>
              <Link to="/">Home</Link>{" "}
              <span>
                <FaChevronRight />
              </span>{" "}
              Contact Us
            </p>
          </div>
        </div>
      </div>
      {/* contact form starts*/}
      <div className="contact mb-90">
        <div className="container">
          <div className="main-title-4 mb-60 text-center">
            <h1>
              <span>Get In Touch</span>
            </h1>
          </div>

          <div className="contact-area">
            <div className="contact-sub-head mb-4">
              <h4>Leave us a message</h4>
            </div>
            <div className="row">
              <div className="col-lg-6 mb-5 mb-lg-0">
                <div className="contact-form">
                  <Formik
                    // enableReinitialize={true}
                    initialValues={defaultDetails}
                    validationSchema={schema}
                    onSubmit={(values) => {
                      doContact(values);
                    }}
                  >
                    <Form>
                      <div className="mb-4">
                        <Field
                          name="fullName"
                          type="text"
                          className="form-control"
                          placeholder="Full Name"
                        />
                        <ErrorMessage
                          name="fullName"
                          render={(msg) => (
                            <div className="text-danger">{msg}</div>
                          )}
                        />
                      </div>
                      <div className="mb-4">
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                        />
                        <ErrorMessage
                          name="email"
                          render={(msg) => (
                            <div className="text-danger">{msg}</div>
                          )}
                        />
                      </div>
                      <div className="mb-4">
                        <Field
                          name="message"
                          as="textarea"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="message"
                          render={(msg) => (
                            <div className="text-danger">{msg}</div>
                          )}
                        />
                      </div>
                      <div class="send-button">
                        <button type="submit">Send</button>
                      </div>
                    </Form>
                  </Formik>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="ps-30 side-contact">
                  <div className="address mb-4">
                    <p>
                      VISTAPLOTS Real Estate Solutions Pvt Ltd, #1, 2nd Floor,
                      M.C.Plaza, 1st Cross, 1st Main, Ganganagar, R.T.Nagar
                      Post, Bangalore-560032
                    </p>
                  </div>
                  <div className="phone mb-4">
                    <a target="_blank" href="tel:+919008005699">
                      +91 9008005699
                    </a>
                  </div>
                  <div className="email mb-4">
                    <a target="_blank" href="mailto:info@vistaplots.com">
                      info@vistaplots.com
                    </a>
                  </div>
                  <div className="map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.1970528549336!2d77.58114691359653!3d13.023120065764228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17b7f8fbbbeb%3A0x55154958119f4b40!2sMC%20Plaza!5e0!3m2!1sen!2sin!4v1667699396192!5m2!1sen!2sin"
                      width="100%"
                      height="210"
                      style={{ border: 0 }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* contact form ends */}

      <Footer />
    </>
  );
};

export default Contact;
